import type { Row, RowData, TableFeature } from '@tanstack/react-table';

export interface DataTableRowInteractionOptions<TData extends RowData> {
  /**
   * DataTable 행의 활성 표시 여부를 설정합니다.
   * 반환값이 `false`인 행은 opacity가 적용됩니다.
   * Checkbox/Radio와 Chevron의 상태에는 영향을 주지 않습니다.
   * 행 클릭, hover, context menu 동작은 이 옵션으로 제어하지 않습니다.
   *
   * @default true
   */
  enableRowInteraction?: boolean | ((row: Row<TData>) => boolean);
}

export interface DataTableRowInteractionRow {
  /**
   * 해당 행의 활성 표시 여부를 반환합니다.
   * Feature가 등록되지 않은 기존 Table 인스턴스와의 호환을 위해 optional 메서드로 제공합니다.
   */
  getCanInteract?: () => boolean;
}

declare module '@tanstack/react-table' {
  interface TableOptionsResolved<TData extends RowData>
    extends DataTableRowInteractionOptions<TData> {}

  // TanStack 원본 선언과 제네릭 이름이 같아야 합니다.
  // eslint-disable-next-line unused-imports/no-unused-vars
  interface Row<TData extends RowData> extends DataTableRowInteractionRow {}
}

export const RowInteraction: TableFeature<unknown> = {
  createRow: (row, table) => {
    row.getCanInteract = () => {
      const enableRowInteraction = table.options.enableRowInteraction;
      return typeof enableRowInteraction === 'function'
        ? enableRowInteraction(row)
        : (enableRowInteraction ?? true);
    };
  },
};
